import React, {useEffect, useState} from 'react';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Chip,
  Container,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import Navbar from "./navBar/Navbar";
import {BASE_URL} from "../utils/BaseUrl";
import axios from 'axios';
import {InputLabel} from "@material-ui/core";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {Divider} from "antd";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteIcon from '@mui/icons-material/Delete';

function VideoLessonsUploader () {
  const [videoList, setVideoList] = useState([]);
  const [customName, setCustomName] = useState('');
  const [teacherName, setTeacherName] = useState('');
  const [subject, setSubject] = useState('');
  const [lessonName, setLessonName] = useState('');
  const [selectedClass, setSelectedClass] = useState('');
  const [subjects, setSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState('');
  const [teacherFilter, setTeacherFilter] = useState('');
  const [classFilter, setClassFilter] = useState('');
  const [subjectFilter, setSubjectFilter] = useState('');

// Extract unique values for dropdowns (optional)
  const uniqueTeachers = [...new Set(videoList.map(v => v.teacher))];
  const uniqueClasses = [...new Set(videoList.map(v => v.studentClass))];
  const uniqueSubjects = [...new Set(videoList.map(v => v.subject))];

// Filtered video list
  const filteredVideos = videoList.filter(video =>
    (teacherFilter ? video.teacher === teacherFilter : true) &&
    (classFilter ? video.studentClass === classFilter : true) &&
    (subjectFilter ? video.subject === subjectFilter : true)
  );

  const handleCopy = (code) => {
    navigator.clipboard.writeText(code);
  };

  class SchoolSubject {
    constructor (name, maxGrade, minGrade) {
      this.name = name;
      this.maxGrade = maxGrade;
      this.minGrade = minGrade;
    }
  }

// Define subjects for various classes
  const secondaryTenthSubjects = [
    new SchoolSubject('هندسة', 200, 80),
    new SchoolSubject('جبر', 200, 80),
    new SchoolSubject('علم احياء', 200, 80),
    new SchoolSubject('فيزياء', 200, 80),
    new SchoolSubject('كيمياء', 200, 80),
    new SchoolSubject('لغة عربية', 500, 200),
    new SchoolSubject('لغة فرنسية \\ روسية', 300, 120),
    new SchoolSubject('لغة انكليزية', 400, 160),
    new SchoolSubject('حاسوب', 200, 80),
    new SchoolSubject('تربية إسلامية', 200, 80),
    new SchoolSubject('تربية وطنية', 200, 80),
    new SchoolSubject('جغرافيا', 200, 80),
    new SchoolSubject('تاريخ', 200, 80),
    new SchoolSubject('فلسفة', 200, 80),
    new SchoolSubject('اثراء', 200, 80),
  ];
  const secondarySubjects = [
    new SchoolSubject('هندسة', 300, 120),
    new SchoolSubject('جبر', 300, 120),
    new SchoolSubject('علم احياء', 300, 120),
    new SchoolSubject('فيزياء', 400, 120),
    new SchoolSubject('كيمياء', 200, 80),
    new SchoolSubject('لغة عربية', 400, 160),
    new SchoolSubject('لغة فرنسية \\ روسية', 300, 120),
    new SchoolSubject('لغة انكليزية', 300, 120),
    new SchoolSubject('حاسوب', 200, 80),
    new SchoolSubject('تربية إسلامية', 200, 80),
    new SchoolSubject('تربية وطنية', 200, 80),
  ];
  const elementarySubjects = [
    new SchoolSubject('رياضيات', 600, 240),
    new SchoolSubject('لغة عربية', 600, 300),
    new SchoolSubject('لغة فرنسية \\ روسية', 300, 120),
    new SchoolSubject('لغة انكليزية', 400, 160),
    new SchoolSubject('حاسوب', 200, 80),
    new SchoolSubject('اجتماعيات', 600, 240),
    new SchoolSubject('اثراء', 200, 80),
    new SchoolSubject('تربية إسلامية', 200, 80),
    new SchoolSubject('فيزياء وكيماء', 200, 80),
    new SchoolSubject('علوم', 200, 80),
  ];

  const subjectsByClass = {
    'الأول': elementarySubjects,
    'الثاني': elementarySubjects,
    'الثالث': elementarySubjects,
    'الرابع': elementarySubjects,
    'الخامس': elementarySubjects,
    'السادس': elementarySubjects,
    'السابع': elementarySubjects,
    'الثامن': elementarySubjects,
    'التاسع': elementarySubjects,
    'العاشر': secondaryTenthSubjects,
    'الحادي عشر': secondarySubjects,
    'الثاني عشر': secondarySubjects,
  };
  const theme = createTheme({
    direction: 'rtl',
    typography: {
      fontFamily: `"Cairo", "Roboto", "Helvetica", "Arial", sans-serif`,
    },
  });
  useEffect(() => {
    // Load Cloudinary widget
    const script = document.createElement('script');
    script.src = 'https://upload-widget.cloudinary.com/global/all.js';
    script.async = true;
    document.body.appendChild(script);
    fetchVideos();

  }, []);

  function fetchVideos () {
    axios.get(BASE_URL + 'api/videos').then(async (res) => {
      const videos = await Promise.all(res.data.map(async (video) => {
        const codesRes = await axios.get(BASE_URL + 'api/access-codes', {
          params: {videoUrl: video.url}
        });
        return {...video, codes: codesRes.data};
      }));
      setVideoList(videos);
    });
  }

  const openWidget = () => {
    if (!teacherName || !selectedSubject || !lessonName || !selectedClass) {
      alert('يرجى تعبئة جميع الحقول قبل التحميل');
      return;
    }

    const widget = window.cloudinary.createUploadWidget(
      {
        cloudName: 'dtatcjt76',
        uploadPreset: 'video_upload',
        sources: ['local', 'url'],
        resourceType: 'video',
        multiple: false,
        publicId: lessonName.trim().replace(/\s+/g, '_'),
        eager: [{streaming_profile: "full_hd", format: "m3u8"}]
      },
      (error, result) => {
        if (!error && result && result.event === 'success') {
          const {secure_url, created_at} = result.info;

          // Inside upload widget success callback:
          const newVideo = {
            lessonName: lessonName,
            teacher: teacherName,
            subject: selectedSubject,
            studentClass: selectedClass,
            url: secure_url
          };

          axios.post(BASE_URL + 'api/videos', newVideo)
            .then(() => {
              setVideoList(prevList => [newVideo, ...prevList]);
              setTeacherName('');
              setSubject('');
              setLessonName('');
            })
            .catch(err => {
              console.error('Failed to save video:', err);
            });
        }
      }
    );

    widget.open();
  };
  const handleDeleteCode = (codeId) => {
    if (!window.confirm("هل أنت متأكد من حذف هذا الكود؟")) return;

    fetch(BASE_URL + `api/access-codes/${codeId}`, {
      method: 'DELETE'
    }).then(() => {
      fetchVideos(); // Refresh the video list
    });
  };

  const loadSubjectsForClass = (selectedClass) => {
    const subjects = subjectsByClass[ selectedClass ] || [];
    setSubjects(subjects);
    setSelectedSubject(''); // Reset selected subject when class changes
  };
  const handleGenerateCode = async (video) => {

    const studentNum = prompt("أدخل رقم الطالب:");
    if (!studentNum) return;

    const response = await fetch(`${BASE_URL}api/access-codes`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        videoUrl: video.url,
        studentNum,
        videoId: video.id
      })
    });

    if (response.ok) {
      fetchVideos(); // refresh list with new code
    }
  };

  const handleDeleteVideo = (id) => {
    if (!window.confirm("هل أنت متأكد من حذف الفيديو وكل الأكواد المرتبطة به؟")) return;

    fetch(`${BASE_URL}api/videos/${id}`, {
      method: "DELETE",
    }).then(() => fetchVideos());
  };

  return (
    <ThemeProvider theme={theme}>
      <div style={{backgroundColor: '#f4f6f8', minHeight: '100vh', direction: 'rtl'}}>
        <Navbar/>
        <Container maxWidth="xl" sx={{py: 2}}>
          <Typography variant="h4" gutterBottom>
            تحميل فيديوهات الدروس
          </Typography>
          <Grid container spacing={2} direction="row">
            <Grid item xs={2}>
              <FormControl fullWidth margin="normal">
                <InputLabel>اسم المعلم</InputLabel>
                <TextField
                  label="اسم المعلم"
                  value={teacherName}
                  onChange={(e) => setTeacherName(e.target.value)}

                />
              </FormControl>
            </Grid>

            <Grid item xs={2}>
              <FormControl fullWidth margin="normal">
                <InputLabel>الصف</InputLabel>
                <Select
                  value={selectedClass}
                  onChange={(e) => {
                    setSelectedClass(e.target.value);
                    loadSubjectsForClass(e.target.value);
                  }}
                  label="الصف"
                >
                  <MenuItem value="">اختر الصف</MenuItem>
                  {Object.keys(subjectsByClass).map((classOption, index) => (
                    <MenuItem key={index} value={classOption} dir="rtl">
                      {classOption}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={2}>
              <FormControl fullWidth margin="normal">
                <InputLabel>المادة</InputLabel>
                <Select
                  value={selectedSubject}
                  onChange={(e) => {
                    setSelectedSubject(e.target.value);
                  }}
                  label="المادة"
                >
                  <MenuItem value="">اختر المادة</MenuItem>
                  {subjects.map((subject, index) => (
                    <MenuItem key={index} value={subject.name}>
                      {subject.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={2}>
              <FormControl fullWidth margin="normal">
                <InputLabel>اسم الدرس</InputLabel>
                <TextField
                  value={lessonName}
                  onChange={(e) => setLessonName(e.target.value)}
                />
              </FormControl>
            </Grid>
            <Button variant="outlined" color="primary" onClick={openWidget}>
              تحميل فيديو
            </Button>
          </Grid>
          <Divider/>
          <Typography variant="h4" gutterBottom>
            فيديوهات الدروس
          </Typography>
          <Grid container spacing={2} sx={{mb: 2}}>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                select
                label="المعلم"
                value={teacherFilter}
                onChange={(e) => setTeacherFilter(e.target.value)}
              >
                <MenuItem value="">الكل</MenuItem>
                {uniqueTeachers.map((teacher, idx) => (
                  <MenuItem key={idx} value={teacher}>{teacher}</MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                select
                label="الصف"
                value={classFilter}
                onChange={(e) => setClassFilter(e.target.value)}
              >
                <MenuItem value="">الكل</MenuItem>
                {uniqueClasses.map((cls, idx) => (
                  <MenuItem key={idx} value={cls}>{cls}</MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                select
                label="المادة"
                value={subjectFilter}
                onChange={(e) => setSubjectFilter(e.target.value)}
              >
                <MenuItem value="">الكل</MenuItem>
                {uniqueSubjects.map((subj, idx) => (
                  <MenuItem key={idx} value={subj}>{subj}</MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>

          {
            filteredVideos.length > 0 && (
              <Table sx={{mt: 4}} dir="rtl">
                <TableHead>
                  <TableRow>
                    <TableCell><strong>اسم الدرس</strong></TableCell>
                    <TableCell><strong>المعلم</strong></TableCell>
                    <TableCell><strong>الصف</strong></TableCell>
                    <TableCell><strong>المادة</strong></TableCell>
                    <TableCell><strong>الأكواد</strong></TableCell>
                    <TableCell><strong>تاريخ الرفع</strong></TableCell>
                    <TableCell><strong>حذف</strong></TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {filteredVideos.map((video, index) => (
                    <TableRow key={index}>
                      <TableCell>{video.lessonName}</TableCell>
                      <TableCell>{video.teacher}</TableCell>
                      <TableCell>{video.studentClass}</TableCell>
                      <TableCell>{video.subject}</TableCell>
                      <TableCell>
                        <Button size="small" variant="outlined" onClick={() => handleGenerateCode(video)}>
                          إنشاء كود
                        </Button>

                        {/* Collapsible Code List */}
                        {video.codes && video.codes.length > 0 && (
                          <Accordion sx={{mt: 1}}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                              <Typography fontSize="14px">عرض الأكواد ({video.codes.length})</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              {/* Summary above the list */}
                              <Box mb={2}>
                                <Typography variant="body2" color="text.secondary">
                                  عدد الأكواد: {video.codes.length} |
                                  المستخدمة: {video.codes.filter(c => c.used).length} | غير
                                  المستخدمة: {video.codes.filter(c => !c.used).length}
                                </Typography>
                              </Box>

                              {/* Code list */}
                              <Box display="flex" flexDirection="column" gap={1}>
                                {video.codes.map((codeObj, i) => (
                                  <Paper
                                    key={i}
                                    elevation={1}
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between',
                                      padding: 1,
                                      borderRadius: 1,
                                      backgroundColor: codeObj.used ? '#fbe9e7' : '#e8f5e9'
                                    }}
                                  >
                                    <Box display="flex" flexDirection="column" gap={0.5}>
                                      <Box display="flex" alignItems="center" gap={1}>
                                        <Typography variant="body2" sx={{fontWeight: 'bold'}}>
                                          {codeObj.code}
                                        </Typography>
                                        <Typography variant="caption" color="text.secondary">
                                          الطالب: {codeObj.studentName}
                                        </Typography>
                                        <Chip
                                          label={codeObj.used ? 'تم الاستخدام' : 'غير مستخدم'}
                                          size="small"
                                          color={codeObj.used ? 'error' : 'success'}
                                          variant="outlined"
                                        />
                                      </Box>
                                      <Typography variant="caption" color="text.secondary">
                                        تم الإنشاء: {new Date(codeObj.createdAt).toLocaleString('ar-EG')}
                                      </Typography>
                                    </Box>

                                    {/* Actions: copy & delete */}
                                    <Box display="flex" alignItems="center" gap={1}>
                                      <Tooltip title="نسخ الكود">
                                        <IconButton onClick={() => handleCopy(codeObj.code)} size="small">
                                          <ContentCopyIcon fontSize="small"/>
                                        </IconButton>
                                      </Tooltip>
                                      <Tooltip title="حذف الكود">
                                        <IconButton onClick={() => handleDeleteCode(codeObj.code)} size="small"
                                                    color="error">
                                          <DeleteIcon fontSize="small"/>
                                        </IconButton>
                                      </Tooltip>
                                    </Box>
                                  </Paper>
                                ))}
                              </Box>
                            </AccordionDetails>
                          </Accordion>
                        )}
                      </TableCell>
                      <TableCell>{video.uploadedAt}</TableCell>
                      <TableCell>

                        <Button
                          size="small"
                          color="error"
                          variant="outlined"
                          onClick={() => handleDeleteVideo(video.id)}
                        >
                          حذف الفيديو
                        </Button>

                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )
          }
        </Container>
      </div>
    </ThemeProvider>
  );
}

export default VideoLessonsUploader;
